package com.siriusxm.mce.auth.browser

import com.siriusxm.cmc.CMCContainer
import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.auth.*
import io.ktor.client.plugins.auth.providers.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.statement.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json

/**
 * Utility to install authentication into an HttpClient using
 * the CMC Container tokens, handling refresh automatically.
 */
public fun CMCContainer.installAuth(config: HttpClientConfig<*>) {
    config.apply {
        install(Auth) {
            bearer {
                loadTokens {
                    // we just pass the access token. Since the container
                    // takes care of refresh, we don't need to access it.
                    BearerTokens(viewer.accessToken, viewer.accessToken)
                }
                refreshTokens {
                    this@installAuth.viewer.refresh().await()
                    BearerTokens(
                        viewer.accessToken,
                        viewer.accessToken
                    )
                }
            }
        }
    }
}

/**
 * Creates a service client suitable for CMC container authenticated services.
 * @param additionalConfig a callback for additional configuration of the client after the default
 * configuration is applied.
 */
public fun CMCContainer.sxmServiceClient(additionalConfig: HttpClientConfig<*>.() -> Unit = {}): HttpClient {
    val cmc = this
    return HttpClient {
        install(ContentNegotiation) {
            json(Json {
                isLenient = true
                ignoreUnknownKeys = true
            })
        }
        cmc.installAuth(this)

        HttpResponseValidator {
            validateResponse { response ->
                if (response.status.value >= 400) {
                    throw ClientRequestException(response, response.bodyAsText())
                }
            }
        }

        additionalConfig()
    }
}